import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=11f0faaf&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f0faaf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11f0faaf')) {
      api.createRecord('11f0faaf', component.options)
    } else {
      api.reload('11f0faaf', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=11f0faaf&scoped=true&", function () {
      api.rerender('11f0faaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21E7LEyCdgPhK/JS/comp/Accordion.vue"
export default component.exports